import { dew as _browserIndexDew } from "./key_stores/browser-index";
import { dew as _commonIndexDew } from "./common-index";
import { dew as _browserConnectDew } from "./browser-connect";
import * as _errorPolyfill2 from "error-polyfill";

var _errorPolyfill = "default" in _errorPolyfill2 ? _errorPolyfill2.default : _errorPolyfill2;

var exports = {},
    _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;

  var __createBinding = exports && exports.__createBinding || (Object.create ? function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
      enumerable: true,
      get: function () {
        return m[k];
      }
    });
  } : function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
  });

  var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function (o, v) {
    Object.defineProperty(o, "default", {
      enumerable: true,
      value: v
    });
  } : function (o, v) {
    o["default"] = v;
  });

  var __importStar = exports && exports.__importStar || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

    __setModuleDefault(result, mod);

    return result;
  };

  var __exportStar = exports && exports.__exportStar || function (m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
  };

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /** @hidden @module */

  exports.keyStores = __importStar(_browserIndexDew());

  __exportStar(_commonIndexDew(), exports);

  __exportStar(_browserConnectDew(), exports);

  _errorPolyfill;
  return exports;
}